export default __webpack_public_path__ + "static/bravo-1-a2c7abbb8087d3bdbb0c2fbc11120175.jpg";